import { useMemo } from 'react'

import { SmartImage } from './SmartImage'

import { Box } from '@/components/ui/base'

interface ReviewImageThumbnailsProps {
  images: string[]
  onImageClick: (index: number) => void
  maxThumbnails?: number
}

export const ReviewImageThumbnails = ({ images, onImageClick, maxThumbnails = 5 }: ReviewImageThumbnailsProps) => {
  const displayImages = useMemo(() => {
    if (!images || images.length === 0) return []
    return images.slice(0, maxThumbnails)
  }, [images, maxThumbnails])

  if (!images || images.length === 0) return null

  const remainingCount = images.length - maxThumbnails

  return (
    <Box marginTop="s">
      <div
        style={{
          display: 'flex',
          gap: '6px',
          alignItems: 'center',
        }}
      >
        {displayImages.map((imageUrl, index) => (
          <div
            key={index}
            role="button"
            tabIndex={0}
            style={{
              aspectRatio: '1',
              border: '1px solid #d5dbdb',
              borderRadius: '4px',
              overflow: 'hidden',
              cursor: 'pointer',
              width: '40px',
              height: '40px',
            }}
            onClick={() => onImageClick(index)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onImageClick(index)
              }
            }}
          >
            <SmartImage
              image={imageUrl}
              size="small"
              isTemp={false}
              alt={`Review image ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
        ))}
        {remainingCount > 0 && (
          <div
            role="button"
            tabIndex={0}
            style={{
              width: '40px',
              height: '40px',
              border: '1px solid #d5dbdb',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f2f3f3',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#5f6b7a',
              cursor: 'pointer',
            }}
            onClick={() => onImageClick(maxThumbnails)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onImageClick(maxThumbnails)
              }
            }}
          >
            +{remainingCount}
          </div>
        )}
      </div>
    </Box>
  )
}
